export const likeList = {
  title: "いいね",
  tabReceived: "相手から",
  tabSent: "自分から",
  emptyReceived: "相手からのいいねはまだありません",
  emptySent: "自分から送ったいいねはまだありません",
} as const;
